import genererPatrimoineNomenclature from '@/services/logistique/demandeImpression/genererDemandeImpression';
import hasProperty from 'lodash/has';

export function fillPatrimoineNomenclatureWithData(patrimoineNomenclature, ligne, dispositifs,
  nomenclatures) {
  const errors = [];
  const nomenclature = nomenclatures.find(c => c.libelle === ligne.nomenclature);
  patrimoineNomenclature.nomenclatureTypeId = nomenclature.id;

  const dispositif = dispositifs.find(d => d.code === ligne.codeDispositif);
  patrimoineNomenclature.id = dispositif.id;
  const schema = JSON.parse(nomenclature.schema);

  const value = Object.keys(schema.properties).reduce((acc, key) => {
    acc[key] = schema.properties[key].default;
    if (hasProperty(ligne, key)) acc[key] = ligne[key];
    return acc;
  }, {});
  patrimoineNomenclature.nomenclature = JSON.stringify(value);
  if (errors.length > 0) throw errors;
  return patrimoineNomenclature;
}

export default function genererpatrimoineNomenclature(ligne, dispositifs, nomenclatures) {
  const patrimoineNomenclature = genererPatrimoineNomenclature();
  return fillPatrimoineNomenclatureWithData(patrimoineNomenclature, ligne, dispositifs,
    nomenclatures);
}
